import { Fragment, type ReactNode } from "react";
import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: ReactNode;
  to?: string;
}

export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav
      aria-label="Хлебные крошки"
      className="text-sm text-muted-foreground"
      data-testid="breadcrumbs"
    >
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((item, idx) => {
          const last = idx === items.length - 1;
          return (
            <Fragment key={idx}>
              <li className="flex items-center">
                {item.to && !last ? (
                  <Link to={item.to} className="hover:underline">
                    {item.label}
                  </Link>
                ) : (
                  <span aria-current={last ? "page" : undefined}>
                    {item.label}
                  </span>
                )}
              </li>
              {!last && (
                <li aria-hidden="true" className="text-muted-foreground/60">
                  /
                </li>
              )}
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
